import { environmentConfig } from "@src/appV2/environment";
import { DeploymentEnvironmentName } from "@src/appV2/environment/types";

const LOCALHOST_ORIGIN = "http://localhost:3000";
// CloudFront distribution serving admin preview environments at /pr-*/ paths
const ADMIN_PREVIEW_ORIGIN = "https://dokw00pll1szs.cloudfront.net";

export function getAllowedImpersonationOrigins(): Set<string> {
  const origins = new Set<string>();

  const configuredUrl = environmentConfig.REACT_APP_ADMIN_WEB_APP_URL;
  if (configuredUrl) {
    origins.add(new URL(configuredUrl).origin);
  }

  if (environmentConfig.REACT_APP_ENVIRONMENT_NAME !== DeploymentEnvironmentName.PRODUCTION) {
    origins.add(LOCALHOST_ORIGIN);
    origins.add(ADMIN_PREVIEW_ORIGIN);
  }

  return origins;
}
